export class GlobalConstants {
    public static GetAdminInfoUrl = "Account/GetAdminInfo";
    public static FindBySessionUrl = "api/User/UserInformation";
    public static UserInformationPortalLogin = "api/User/GetInternalUserInfo";
    public static FindAppsBySession = "api/Application/Application";
    public static FindAppsByInternalUserSession = "api/Application/Application";
    public static GetUserInfrastructure = "api/MultipleSegmentOrders/ValidateUserOrderSegment";
    public static FindInternalUserInformation = "api/User/InternalUserInformation";
    public static Login= "login";
}
